import React from 'react';

const Section = ({ title, children }) => (
    <div className="mb-8">
        <h2 className="text-sm font-bold mb-3" style={{ color: 'var(--text)', fontFamily: "var(--font-display)" }}>{title}</h2>
        <div className="text-xs leading-relaxed space-y-2" style={{ color: 'var(--muted)' }}>{children}</div>
    </div>
);

export default function ExclusaoDeDadosPage() {
    return (
        <div className="min-h-screen" style={{ background: 'var(--bg)' }}>
            <div className="max-w-3xl mx-auto px-4 py-12 md:py-20">
                <h1 className="text-4xl sm:text-5xl font-bold mb-2" style={{ color: 'var(--text)', fontFamily: "var(--font-display)" }}>
                    Exclusão de <span style={{ color: 'var(--gold-2)' }}>Dados</span>
                </h1>
                <p className="text-xs mb-10" style={{ color: 'var(--muted)' }}>Lei Geral de Proteção de Dados (LGPD - Lei 13.709/2018)</p>

                <div className="rounded-xl p-6 md:p-8" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }} data-testid="data-deletion-content">
                    <Section title="Como solicitar a exclusão">
                        <p>O SuperVitrine respeita sua privacidade. Você tem o direito de solicitar a exclusão dos seus dados pessoais a qualquer momento.</p>
                        <p>Envie um e-mail para o endereço abaixo informando:</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Seu nome completo</li>
                            <li>E-mail cadastrado no SuperVitrine</li>
                            <li>Descrição do que deseja excluir (conta completa ou dados específicos)</li>
                        </ul>
                        <p className="mt-3 text-sm font-semibold" style={{ color: 'var(--gold-2)' }}>suporte@supervitrineofertas.com</p>
                    </Section>

                    <Section title="Quais dados podem ser excluídos">
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Dados de cadastro (nome, e-mail, telefone)</li>
                            <li>Dados de perfil e preferências</li>
                            <li>Histórico de navegação e interações no sistema</li>
                            <li>Dados de integração bancária (Open Finance / Belvo)</li>
                            <li>Dados de autenticação (Google, Facebook)</li>
                            <li>Conta completa e todos os dados associados</li>
                        </ul>
                    </Section>

                    <Section title="Prazo de atendimento">
                        <p>Sua solicitação será processada em até <strong style={{ color: 'var(--text)' }}>15 dias úteis</strong> após o recebimento do e-mail.</p>
                        <p>Você receberá uma confirmação por e-mail quando a exclusão for concluída.</p>
                    </Section>

                    <Section title="Informações importantes">
                        <ul className="list-disc pl-5 space-y-1">
                            <li>A exclusão é irreversível. Uma vez removidos, os dados não podem ser recuperados.</li>
                            <li>Dados necessários para cumprimento de obrigações legais ou regulatórias podem ser retidos pelo prazo exigido por lei.</li>
                            <li>Se você fez login via Facebook ou Google, a exclusão no SuperVitrine não afeta sua conta nessas plataformas.</li>
                        </ul>
                    </Section>
                </div>
            </div>
        </div>
    );
}
